import { useConfigStore } from "../Stores/Config";
import { useSessionStore } from "../Stores/Session";
import type { TicketChatMessage } from "../Stores/Ticket";
import { presentsAsBot } from "./MessageAuthor";

// Display name for the author of a message — used both by the group header
// above a message and by the quoted-reply attribution. Kept apart from the pure
// predicates in MessageAuthor.ts because it reads the config/session stores.
export const getMessageAuthorName = (
  message?: TicketChatMessage | null,
): string => {
  if (!message) {
    return "";
  }

  const configStore = useConfigStore.getState();
  if (presentsAsBot(message, configStore.config?.ticketHeaderMode)) {
    return message.data?.agentName || configStore.getBotName();
  }

  if (message.user?.firstName) {
    return `${message.user.firstName} ${message.user.lastName ?? ""}`.trim();
  }

  // No populated user → the customer's own message.
  return useSessionStore.getState().getName() || "You";
};
